import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GdlService } from 'src/app/shared/services/gdl-service/gdl.service';
import { SharedService } from 'src/app/shared/services/shared-service/shared.service';

@Component({
  selector: 'wpro-two-steptoggle-popup',
  templateUrl: './two-steptoggle-popup.component.html',
  standalone: false
})
export class TwoSteptogglePopupComponent implements OnInit {

    gdlModal = 'modal';
    gdlFormName = 'twostep-toggled-off';

    @Output() twoFaHidePopup = new EventEmitter<boolean>();
    @Output() twoFaContinue = new EventEmitter();


    constructor(public sharedService: SharedService, public gdlService: GdlService) { }

    ngOnInit(): void {
      window.scroll(0, 0);
    }

    closePopup(): void {
      this.twoFaHidePopup.emit(true);
      this.gdlService.triggerGdlLogEvent(this.gdlModal, 'dismiss', { name: this.gdlFormName });
    }

    continueClicked(): void {
      this.sharedService.isEditScreen = false;
      this.twoFaContinue.emit(true);
      this.gdlService.triggerGdlLogEvent(this.gdlModal, 'confirm', { name: this.gdlFormName, choice: 'confirm' });
    }
  }
